var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    fill: "#81D61E",
    stroke: "#DBDBDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4167 8.75H10.5833C9.575 8.75 8.75 9.575 8.75 10.5833V23.4167C8.75 24.425 9.56583 25.25 10.5833 25.25H23.4167C24.425 25.25 25.25 24.425 25.25 23.4167V10.5833C25.25 9.575 24.425 8.75 23.4167 8.75ZM23.4167 23.4167H10.5833V20.6667H13.8467C14.4792 21.7575 15.6525 22.5 17.0092 22.5C18.3658 22.5 19.53 21.7575 20.1717 20.6667H23.4167V23.4167ZM23.4167 18.8333H18.8425C18.8425 19.8417 18.0175 20.6667 17.0092 20.6667C16.0008 20.6667 15.1758 19.8417 15.1758 18.8333H10.5833V10.5833H23.4167V18.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.5ca41e4ef4f14a5efde78361e6788721.svg";
export { ForwardRef as ReactComponent };